import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../rootReducer';

export const userSliceSelector = createSelector(
  (state: RootState) => state.user,
  (state) => state
);

export const userLoadingSelector = createSelector(userSliceSelector, (state) => state.loading);
export const userSelector = createSelector(userSliceSelector, (state) => state.data);
